import dayjs from 'dayjs'
import Id from '@/utils/Id'

export const SERVER_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ssZZ'
export const SERVER_DATE_FORMAT = 'YYYY-MM-DD'
export const SERVER_TIME_FORMAT = 'HH:mm:ssZZ'

// short human label for an IANA timezone, e.g. "America/Vancouver" -> "Vancouver"
export const timezoneCity = (timezone) => {
  if (!timezone) return ''
  const parts = timezone.split('/')
  return parts[parts.length - 1].replace(/_/g, ' ')
}

// current UTC offset label for an IANA timezone, e.g. "America/Vancouver" -> "UTC-7"
export const timezoneUtcOffset = (timezone) => {
  if (!timezone) return ''
  const offsetMinutes = dayjs().tz(timezone).utcOffset()
  const sign = offsetMinutes >= 0 ? '+' : '-'
  const abs = Math.abs(offsetMinutes)
  const hours = Math.floor(abs / 60)
  const minutes = abs % 60
  return `UTC${sign}${hours}${minutes ? ':' + String(minutes).padStart(2, '0') : ''}`
}

// Two IANA identifiers can name the very same wall clock: a floor set to "America/Vancouver" viewed
// from a browser that reports "America/Los_Angeles" is not a timezone difference the user can see.
// Comparing the identifiers alone flags those as a mismatch, so compare what actually shows up on
// screen right now - the current UTC offset. Zones that drift apart later in the year (e.g.
// "America/Phoenix" vs "America/Los_Angeles", which share an offset outside DST but not during it)
// count as the same while their offsets match, and start differing once they actually do.
export const isSameTimezone = (a, b) => {
  if (a === b) return true
  if (!a || !b) return false
  const now = dayjs()
  return now.tz(a).utcOffset() === now.tz(b).utcOffset()
}

// AppDateSelect (and similar pickers) emit a plain browser-zone dayjs — only its Y-M-D is
// meaningful (the calendar date the user picked); re-anchor it to a target timezone before
// applying a time on it, so the result stays correctly tagged to that timezone
export const toBuildingDate = (date, timezone) => dayjs.tz(date.format('YYYY-MM-DD'), 'YYYY-MM-DD', timezone)

export const createDeskEvent = () => {
  return {
    id: Id(),
    desk_id: null,
    employee_id: null,
    set_id: null,
    start: null,
    end: null,
    remind: null
  }
}
